// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3DVMp","col":"Table_col__2nH0M","fulfillmentStatus":"Table_fulfillmentStatus__3hfM1","emailCol":"Table_emailCol__1hFO5"};